export class NavigationItem {
    constructor(
        public Name: string,
        public View: string,
        public Path: string) { }

    public CanNavigation: boolean;
 }


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/objects/navigation/navigation-item.ts